{
    "name": "erp-angular-frontend",
    "version": "1.14.2",
    "description": "BizCare ERP — Angular web frontend",
    "author": "https://themeforest.net/user/srcn",
    "license": "https://themeforest.net/licenses/standard",
    "private": true,
    "scripts": {
        "ng": "ng",
        "postinstall": "node scripts/sync-pdf-fonts.cjs",
        "clean": "node scripts/clean-angular-cache.cjs",
        "prestart": "npm run clean",
        "start": "ng serve --configuration development --port=4201 --o",
        "start:clean": "npm run clean && ng serve --configuration development --port=4201 --o",
        "start:demo": "ng serve --configuration demo --port=4201 --o",
        "start:live": "ng serve --configuration production --port=4201 --o",
        "start:prod": "ng serve --configuration production --port=4201 --o",
        "start:pwa": "npm run build && npx http-server dist/fuse/live -p 4201 -c-1",
        "build": "ng build --configuration production",
        "prebuild:dev": "node scripts/bump-version.cjs",
        "build:dev": "ng build --configuration development",
        "build:demo": "ng build --configuration demo",
        "build:prod": "ng build --configuration production",
        "build:all": "npm run build:dev && npm run build:demo && npm run build:prod",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "test:ci": "ng test --watch=false --browsers=ChromeHeadless",
        "lint": "ng lint",
        "lint:fix": "ng lint --fix"
    },
    "dependencies": {
        "@angular/animations": "19.0.5",
        "@angular/cdk": "19.0.4",
        "@angular/common": "19.0.5",
        "@angular/compiler": "19.0.5",
        "@angular/core": "19.0.5",
        "@angular/forms": "19.0.5",
        "@angular/material": "19.0.4",
        "@angular/material-luxon-adapter": "19.0.4",
        "@angular/platform-browser": "19.0.5",
        "@angular/platform-browser-dynamic": "19.0.5",
        "@angular/router": "19.0.5",
        "@angular/service-worker": "^19.0.5",
        "@canvas-fonts/arial": "^1.0.4",
        "@canvas-fonts/arial-bold": "^1.0.4",
        "@jsverse/transloco": "7.5.1",
        "@microsoft/signalr": "^10.0.0",
        "@sweetalert2/ngx-sweetalert2": "^14.1.1",
        "@types/leaflet": "^1.9.21",
        "apexcharts": "4.3.0",
        "crypto-js": "4.2.0",
        "dexie": "^4.0.10",
        "file-saver": "^2.0.5",
        "highlight.js": "11.11.1",
        "html2canvas": "^1.4.1",
        "jspdf": "^4.0.0",
        "jspdf-autotable": "^5.0.7",
        "leaflet": "^1.9.4",
        "lodash-es": "4.17.21",
        "luxon": "3.5.0",
        "ng-apexcharts": "1.15.0",
        "ngx-toastr": "^19.1.0",
        "perfect-scrollbar": "1.5.6",
        "qrcode": "^1.5.4",
        "rxjs": "7.8.1",
        "sweetalert2": "^11.26.17",
        "tslib": "2.8.1",
        "xlsx": "^0.18.5",
        "zone.js": "0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "19.0.6",
        "@angular/cli": "19.0.6",
        "@angular/compiler-cli": "19.0.5",
        "@eslint/js": "^9.39.5",
        "@tailwindcss/typography": "0.5.15",
        "@types/chroma-js": "2.4.5",
        "@types/crypto-js": "4.2.2",
        "@types/highlight.js": "10.1.0",
        "@types/jasmine": "5.1.5",
        "@types/lodash": "4.17.13",
        "@types/lodash-es": "4.17.12",
        "@types/luxon": "3.4.2",
        "@types/qrcode": "^1.5.6",
        "angular-eslint": "^19.8.1",
        "autoprefixer": "10.4.20",
        "chroma-js": "2.4.2",
        "eslint": "^9.39.5",
        "jasmine-core": "5.1.2",
        "karma": "6.4.4",
        "karma-chrome-launcher": "3.2.0",
        "karma-coverage": "2.2.1",
        "karma-jasmine": "5.1.0",
        "karma-jasmine-html-reporter": "2.1.0",
        "lodash": "4.17.21",
        "postcss": "8.4.49",
        "prettier": "3.4.2",
        "prettier-plugin-organize-imports": "4.1.0",
        "prettier-plugin-tailwindcss": "0.6.9",
        "tailwindcss": "3.4.17",
        "typescript": "5.6.3",
        "typescript-eslint": "^8.68.0"
    }
}
